module.exports = __webpack_public_path__ + "static/media/cover.bbc69c53.png";